import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function Error() {
  return (
    <>
    <div className="error-page">
        <div className="container">
            <div className="row">

                <div className="col-lg-4 col-md-4">
                    <h1 className="errorhead-1">404</h1>
                </div>

                <div className="col-lg-4 col-md-4">
                    <div className="error-buttonbox">
                        <Link to={"/"} className="default-btn colored-btn">Back To Homepage <Icons name="Longarrow_right"/></Link>
                        <Link to={"/contact"} className="default-btn">Contact Us <Icons name="Longarrow_right"/></Link>
                    </div>
                </div>

                <div className="col-lg-4 col-md-4">
                    <div className="error-imagebox">
                        <span>Error</span>
                        <img src="/image/404.webp" className="img-responsive" alt="404"/>
                    </div>
                </div>

                <div className="col-lg-12">
                    <h2 className="errorhead-2">Not Found</h2>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
